<div fxLayout="column" fxFill>
  <flex-table #flexTable [noHeader]="true" fxFill fxFlex [dataSource]="dataSource" [tableConfig]="tableConfig"
    [columnTemplates]="{client_name: tplClientName, message: tplMessage}" (onSelectionChange)="onSelectionChange($event)">

    <ng-template #tplClientName let-item="row">
      <div>
        <h3 class="ma-0 sms-sender" matline [ngClass]="{'font-weight-bold': item.unread}">
          {{ item.client_name ? item.client_name : item.remote_number|displayPhoneNumber }}
        </h3>
        <div fxLayout="row" fxLayoutAlign="start center">
          <mat-icon *ngIf="item.has_scheduled" class="icon-scheduled">schedule</mat-icon>
          <span>
            {{ item.message_time | timeFormatDateTimeShort }}
          </span>
        </div>
      </div>
    </ng-template>

    <!-- <ng-template #tplTime let-item="row">
      <div fxLayout="row" [ngClass]="{'font-bold': item.unread}">
          {{ item.message_time | timeFormatDateTimeShort }}
      </div>
    </ng-template> -->

    <ng-template #tplMessage let-item="row">
      <div class="sms-message mat-list-text full-width" [ngClass]="{'font-bold': item.unread}">
        <p class="ma-0" matline>{{ (item?.message?.length > 70)? (item.message | slice:0:70)+'..':(item?.message) }}</p>
      </div>
    </ng-template>

  </flex-table>
</div>
